import { AxiosInstance } from "axios";
import { useContext } from "react";
import { AxiosContext } from "~/providers/AxiosProvider";

export const useAxios = (): AxiosInstance => {
  const client = useContext(AxiosContext);

  return client;
};
